import WishlistButton from './WishlistButton';

export default WishlistButton; 